import PropTypes from 'prop-types'
import styled from 'styled-components'

import Checkbox from 'components/Checkbox'
import FieldExplanation from 'components/FieldExplanation'

const CRITICAL_ALERTS_DESCRIPTION = 'Critical alerts consist of issues where primary functionality has been lost and likely require prompt attention.'
const MAJOR_ALERTS_DESCRIPTION = 'Major alerts consist of issues where some functionality has been lost or reduced and may need attention as soon as is convenient.'
const SDA_ALERTS_DESCRIPTION = 'Smart Diagnostics Alerts (SDA) are based on algorithms that run periodically in the cloud and are independent of the alerts triggered within the thermostat or HVAC equipment.  These alerts will not be displayed on the thermostat or in Home.'
const COMPANY_UPDATE_ALERTS_DESCRIPTION = 'Receive periodic company emails about things like new features or requests for feedback.'

const propTypes = {
  alerts: PropTypes.shape({
    criticalAlerts: PropTypes.bool.isRequired,
    majorAlerts: PropTypes.bool.isRequired,
    sdaAlerts: PropTypes.bool.isRequired,
    companyUpdateAlerts: PropTypes.bool.isRequired
  }).isRequired,
  setAlerts: PropTypes.func.isRequired
}

const AlertNotificationCheckboxList = ({ alerts, setAlerts }) => {
  const { criticalAlerts, majorAlerts, sdaAlerts, companyUpdateAlerts } = alerts

  const alertTypes = [
    { title: 'Critical', checked: criticalAlerts, description: CRITICAL_ALERTS_DESCRIPTION, name: 'criticalAlerts' },
    { title: 'Major', checked: majorAlerts, description: MAJOR_ALERTS_DESCRIPTION, name: 'majorAlerts' },
    { title: 'Major SDA', checked: sdaAlerts, description: SDA_ALERTS_DESCRIPTION, name: 'sdaAlerts' },
    { title: 'Company Update', checked: companyUpdateAlerts, description: COMPANY_UPDATE_ALERTS_DESCRIPTION, name: 'companyUpdateAlerts' }
  ]

  return (
    <>
      {_.map(alertTypes, (alertType) => (
        <S.AlertNotificationCheckbox key={alertType.title}>
          <Checkbox
            label={`${alertType.title} Alerts`}
            onChange={() => setAlerts({ ...alerts, ...{ [alertType.name]: !alertType.checked } })}
            checked={alertType.checked}
          />
          <S.FieldExplanation tooltipContent={alertType.description} />
        </S.AlertNotificationCheckbox>
      ))}
    </>
  )
}

AlertNotificationCheckboxList.propTypes = propTypes

export default AlertNotificationCheckboxList

const S = {
  AlertNotificationCheckbox: styled.div`
    display: flex;
    align-items: center;
  `,
  FieldExplanation: styled(FieldExplanation)`
    margin: -6px 0 0 7px;
  `
}
